import Swiper, {
  Navigation,
  Pagination,
  Thumbs,
  FreeMode,
  Autoplay,
} from 'swiper'

const allCardBoxSlider = document.querySelectorAll('.card-box-slider')

if (allCardBoxSlider) {
  allCardBoxSlider.forEach((element) => {
    const nextElement = element
      .closest('.card-box-slider-wrap')
      ?.querySelector('.swiper-button-next') as HTMLElement
    const prevElement = element
      .closest('.card-box-slider-wrap')
      ?.querySelector('.swiper-button-prev') as HTMLElement
    // Card-box slider
    new Swiper(element as HTMLElement, {
      spaceBetween: 30,
      slidesPerGroup: 1,
      //loop: true,
      //loopFillGroupWithBlank: true,
      modules: [Navigation, Pagination],
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: nextElement,
        prevEl: prevElement,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 3,
        },
      },
    })
  })
}

// Tiles slider:
new Swiper('.tile-slider', {
  spaceBetween: 30,
  slidesPerGroup: 1,
  modules: [Navigation, Pagination],

  navigation: {
    nextEl: '.tile-slider-wrap .swiper-button-next',
    prevEl: '.tile-slider-wrap .swiper-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
    1920: {
      slidesPerView: 5,
    },
  },
})

// Products slider:
new Swiper('.products-slider', {
  spaceBetween: 30,
  slidesPerGroup: 1,
  modules: [Navigation, Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
})

// Slider Lightbox:
new Swiper('.slider-lightbox', {
  spaceBetween: 30,
  slidesPerGroup: 1,
  modules: [Navigation, Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 4,
    },
  },
})

// Teaser slider:
new Swiper('.teaser-slider', {
  spaceBetween: 30,
  slidesPerGroup: 1,
  //loop: true,
  //loopFillGroupWithBlank: true,
  modules: [Navigation, Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 4,
    },
  },
})

new Swiper('.contact-slider', {
  spaceBetween: 30,
  slidesPerGroup: 1,
  modules: [Navigation, Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    1190: {
      slidesPerView: 3,
    },
    1500: {
      slidesPerView: 3,
    },
    1600: {
      slidesPerView: 4,
    },
  },
})

new Swiper('.gradientSlider', {
  modules: [Navigation, Pagination, Autoplay],
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  autoplay: {
    delay: 6000,
  },
})

new Swiper('.content-slider', {
  slidesPerGroup: 1,
  slidesPerView: 1,
  modules: [Navigation, Pagination],
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

const ThumbsSwiper = new Swiper('.gallery-slider-thumb', {
  modules: [Navigation, FreeMode],
  slidesPerView: 5,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  watchSlidesProgress: true,
})

// Produkt Gallery Slider
new Swiper('.gallery-slider', {
  modules: [Navigation, Thumbs],
  autoHeight: true,
  thumbs: {
    swiper: ThumbsSwiper,
  },
})

// Hexagon Slider
const hexagon = new Swiper('.hexagon-img-slider', {
  effect: 'coverflow',
  coverflowEffect: {
    rotate: 30,
    slideShadows: false,
  },
})

const hexagonContent = new Swiper('.hexagon-slider-content', {
  grabCursor: true,
  effect: 'creative',
  creativeEffect: {
    prev: {
      shadow: true,
      translate: [0, 0, -400],
    },
    next: {
      translate: ['100%', 0, 0],
    },
  },
})

const allHexagonTrigger = document.querySelectorAll('.hexagon-slider polygon')
allHexagonTrigger.forEach((polygon) =>
  polygon.addEventListener('click', () => {
    allHexagonTrigger.forEach((hexagonTrigger) =>
      hexagonTrigger.classList.remove('active')
    )
    hexagon.slideTo(polygon.dataset.slide, 500, true)
    hexagonContent.slideTo(polygon.dataset.slide, 0, false)
    polygon.classList.add('active')
  })
)
